<template>
  <div class="rank_index" ref="rank_index">
    <div class="rank_index_top">
      <div class="rank_top">投票活动截止到<span>2024年8月31日</span>，最终获奖名单将于<span>10月</span>公布，榜单每日更新一次。</div>
      <ul class="tab_box">
        <li v-for="(item,index) in this.categoryData"
          :key="index"
          :class="{act : ( isActive == item.category ? true : false ) }"
          @click="getRankList(item.category);isActive=item.category;"
          >
          {{item.value}}
          </li>
      </ul>
      <div class="rank_index_icon left_icon"></div>
      <div class="rank_index_icon right_icon"></div>
      <div class="rank_index_fg"></div>
    </div>
    <div class="rank_center_box">
      <div class="rank_list_box" v-if="this.rankdata.length>0">
        <div v-for="(item,index) in this.rankdata"
          :key="item.id"
          class="rank_list"
          :class="getrank_top(index+1)"
        >
          <div class="rank_list_t">
            <span class="rank_name" @click="videoDetail(item.video_url)">{{item.name}}</span>
            <div class="rank_num">
              总得分数：<span>{{item.total_score}}</span>分
            </div>
          </div>
          <div class="rank_list_b">
            <span class="rank_org">{{item.org}}</span>
            <span class="rank_vote">投票数：{{item.total_vote}}人</span>
            <span class="rank_id">视频ID：{{item.id}}</span>
          </div>
          <div class="top_icon top_1" v-if="index==0"></div>
          <div class="top_icon top_2" v-if="index==1"></div>
          <div class="top_icon top_3" v-if="index==2"></div>
          <div class="rank_top_icon" :class="gettop(index+1)"></div>
        </div>
        <!-- <div v-for="(item,index) in this.rankdata.slice(3)"
          :key="index"
          class="rank_list"
        >
          <div class="rank_list_t">
            <span class="rank_name" @click="videoDetail(item.video_url)">{{item.name}}</span>
            <div class="rank_num">
              总得分数：<span>{{item.total_score}}</span>分
            </div>
          </div>
          <div class="rank_list_b">
            <span class="rank_org">{{item.org}}</span>
            <span class="rank_vote">投票数：{{item.total_vote}}人</span>
            <span class="rank_id">视频ID：{{item.id}}</span>
          </div>
          <div class="rank_top_icon" :class="gettop(index+4)"></div>
        </div> -->
      </div>
      <div class="list_null" v-else>暂无数据！！！</div>
    </div>
    
    <!---查看视频弹层--->
    <el-dialog
      title="视频预览"
      :visible.sync="videoPop"
      width="550px"
      top='200px'
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      @close="closeVideoPop"
      center>
      <div class="video_box" v-if="videoUrl">
        <video id="video" width="500" height="350" controls ref='video'>
          <source :src='this.videoUrl' type="video/mp4">
          您的浏览器不支持 video 标签。
        </video>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/ecmascript-6">
import Vue from "vue";
import API from "../api";
import axios from "axios";
import {categoryData} from "../common/js/data";
export default {
  name: "",
  components: {
  },
  data() {
    return {
      username: "",
      category:1,
      rankdata:{},
      baseUrl: '',
      isActive: 1,
      categoryData:categoryData,
      videoPop:false,
      videoUrl:'',

    };
  },
  computed: {
     
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') {
      this.baseUrl = 'http://www.yooc.test';
    } else {
      // 测试环境
      if (process.env.type === 'test') {
        this.baseUrl = 'http://www.yooc.test';
        // 正式环境
      } else {
        this.baseUrl = 'https://www.yooc.me';
      }
    };
    this.getRankList(this.category);
  },
  craeted(){
 
  },
  methods: {
    //获取排行榜
    async getRankList(category){
      var URL =this.Host+'/rank'
      await this.$axios.get(URL,{params:{category:category}})
      .then((res)=>{
        var result = res.data.result
        if(!result){
          // console.error(res.data.message);
          return;
        }
        this.rankdata=res.data.data.courses;
        // console.log(this.rankdata);
      }).catch((error)=>{
        console.error(error);
      }) 
    },
    //视频预览弹窗
    async videoDetail(url){
      // console.log(url);
      this.videoUrl=url;
      this.videoPop=true;
    },
    closeVideoPop(){
      var video=document.getElementById("video");
      video.pause();
      this.videoUrl='';
    },
    getrank_top(index){
      return 'rank_top_'+index;
    },
    gettop(index){
      return 'rank_top_icon_'+index;
    },
  }
};
</script>
<style lang="scss" rel="stylesheet/stylus" type="text/stylus" scoped>
.rank_index{
  padding: 10px 5px;
  .rank_index_top{
    position: relative;
    height: 190px;
    .rank_index_icon{
      width: 13px;
      height: 67px;
      background: url('../assets/images/index_icon.png') no-repeat;
      position: absolute;
      z-index: 2;
    }
    .left_icon{
      top: 73px;
      left: 10px;
    }
    .right_icon{
      top: 73px;
      right: 15px;
    }
    .rank_index_fg{
     width: 1048px;
     height: 3px;
     background: #6990EB;
     position: absolute;
     z-index: 0;
     top: 145px;
     left: 10px;
    }
    .rank_top{
      width: 1100px;
      height: 100px;
      background: url('../assets/images/menu_top.png') no-repeat;
      text-align: center;
      font-size: 18px;
      color: #fff;
      line-height: 100px;
      span{
        font-size: 24px;
        color: #FFF176;
        font-weight: bold;
        margin: 0 3px;
      }
    }
    .tab_box{
      margin-top: 20px;
      height: 55px;
      display: flex;
      justify-content:space-between;
      width: 1100px;
      position: absolute;
      z-index: 1;
      li{
        width: 200px;
        line-height: 55px;
        color: #fff;
        cursor: pointer;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        background: url('../assets/images/menu.png') no-repeat;
      }
      li:hover{
        color: #fff;
        background: url('../assets/images/menu_hover.png') no-repeat;
      }
      .act{
        color: #fff;
        background: url('../assets/images/menu_hover.png') no-repeat;
      }
    }
  }
  .rank_center_box{
    width: 1105px;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 20px 0;
    overflow: hidden;
    margin-top: 15px;
    .rank_list_box{
    padding: 0 70px;
    margin-top: 40px;
    .rank_list{
      margin-bottom: 45px;
      height: 76px;
      background: #F1F1F1;
      border-radius: 38px;
      padding: 0 36px;
      color: #555;
      position: relative;
      .rank_list_t{
        width: 100%;
        font-weight: bold;
        overflow: hidden;
        
        .rank_no{
          float: left;
          width: 30px;
          text-align: center;
          margin-right: 20px;
        }
        .rank_name{
          float: left;
          cursor: pointer;
          width: 550px;
          overflow: hidden;
          font-size: 18px;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-top: 10px;
          padding-left: 55px;
        }
        .rank_num{
          float: right;
          font-size: 14px;
          span{
            color: #FF9B57;
            font-size: 24px;
            margin-right: 3px;
          }
        }
      }
      .rank_list_b{
        width: 100%;
        font-size: 14px;
        overflow: hidden;
        margin-top: 5px;
        .rank_org{
          float: left;
          margin-left: 55px;
        }
        .rank_id{
          float: right;
        }
        .rank_vote{
          float: right;
          margin-left: 50px;
        }
      }
      .top_icon{
        position: absolute;
        width: 63px;
        height: 46px;
        z-index: 1;
        top: -28px;
        left: 25px;
      }
      .top_1{
        background: url('../assets/images/top_1.png') no-repeat;
      }
      .top_2{
        background: url('../assets/images/top_2.png') no-repeat;
      }
      .top_3{
        background: url('../assets/images/top_3.png') no-repeat;
      }
      .rank_top_icon{
        width: 59px;
        height: 36px;
        position: absolute;
        top:19px;
        left: 25px;
      }
      .rank_top_icon_1{
        background: url('../assets/images/01.png') no-repeat;
      }
      .rank_top_icon_2{
        background: url('../assets/images/02.png') no-repeat;
      }
      .rank_top_icon_3{
        background: url('../assets/images/03.png') no-repeat;
      }
      .rank_top_icon_4{
        background: url('../assets/images/04.png') no-repeat;
      }
      .rank_top_icon_5{
        background: url('../assets/images/05.png') no-repeat;
      }
      .rank_top_icon_6{
        background: url('../assets/images/06.png') no-repeat;
      }
      .rank_top_icon_7{
        background: url('../assets/images/07.png') no-repeat;
      }
      .rank_top_icon_8{
        background: url('../assets/images/08.png') no-repeat;
      }
      .rank_top_icon_9{
        background: url('../assets/images/09.png') no-repeat;
      }
      .rank_top_icon_10{
        background: url('../assets/images/10.png') no-repeat;
      }
    }
    .rank_top_1{
      background: #F97B58;
      color: #fff;
      .rank_num{
        span{
          color: #FFEE20!important;
        }
      }
    }
    .rank_top_2{
      background: #FF9B57;
      color: #fff;
      .rank_num{
        span{
          color: #FFEE20!important;
        }
      }
    }
    .rank_top_3{
      background: #FFBD57;
      color: #fff;
      .rank_num{
        span{
          color: #FFEE20!important;
        }
      }
    }
  }
  .list_null{
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    margin: 15px 0;
  }
  }
  
}
  
</style>


// WEBPACK FOOTER //
// rank.vue?dee37c2a